module.exports = __webpack_public_path__ + "static/media/woodcutters_axe.ef4729c5.png";